import { PublicKey } from "@solana/web3.js";

export const DEFAULT_TOKEN_DECIMALS = 6;

export const ZERO_TS = 0;

export const SWAP_PROGRAM_ID = new PublicKey(
  "SSwpkEEcbUqx4vtoEByFjSkhKdCT862DNVb52nZg1UZ",
);
